import * as types from './mutation_types'

export default {
  async setProject({commit, state}, payload) {
    commit(types.SET_PROJECT, payload);
  },

  setProjectValues({ commit }, payload ){
  	commit(types.SET_PROJECT_VALUES, payload);
  }
}
